<script>
import TitlePage from "@/components/title-page";

export default {
  name: "create-store-instruction",
  components: {
    TitlePage
  },
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      title: "GIAN HÀNG TRỰC TUYẾN",
      currentImg: 0,
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      locationStoreLink: ''
    };
  },
  created() {
    this.locationStoreLink = `${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}`
  },
  methods: {
    // Copy URL to clipboard
    copyURL() {
      navigator.clipboard.writeText(`${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}`);
      this.$bvToast.toast(`Sao chép liên kết thành công!`, {
        title: `Thông báo`,
        autoHideDelay: `1000`,
        variant: `success`,
        toaster: `b-toaster-top-center`,
        solid: true,
        appendToast: true,
      });
    },

    toLinkStoreOnline() {
      window.open(`${process.env.VUE_APP_STORE_ONLINE}/store/${this.inforMerchant.aliasName}`, "_blank");
    }
  },
};
</script>

<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_ONLINE_STORE_VIEW')">
      <TitlePage :title="title" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body" style="margin-bottom: 77px; padding-top: 30px;">
              <div class="text-center">
                <h5 class="mb-0"><b>Khởi tạo gian hàng trực tuyến thành công</b></h5>
                <p>Chúc mừng bạn đã có gian hàng trực tuyến với NextShop.
                  <br />
                  Hãy chia sẻ liên kết trang cho khách hàng ngay nhé!
                </p>
                <div class="col-lg-5 mx-auto">
                  <span class="">
                    <img src="@/assets/images/imgpsh_fullsize_anim.png" />
                  </span>
                </div>
                <div class="col-lg-4 mx-auto">
                  <div class="form-group">
                    <b-form-input
                    id="formrow-firstname-input"
                    class="text-center readonly-primary"
                    type="text"
                    v-model="locationStoreLink"
                    readonly
                    />
                  </div>
                </div>

                <div class="button-row mt-2">
                  <b-button 
                  variant="outline-primary"
                  class="mx-2"
                  v-if="dataPermission && dataPermission.includes('NSH_ONLINE_STORE_VIEW')"
                  @click="toLinkStoreOnline()">
                    Xem gian hàng
                  </b-button>
                  <b-button 
                  variant="primary" 
                  class="mx-2"
                  @click="copyURL()">
                    Chia sẻ ngay
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>